/**
 * Central registry of engine base URLs for all local/remote engine services.
 * All URLs read from VITE_ environment variables (see env.example and PORT_ALLOCATION.md).
 * Never hardcode localhost:4xxx anywhere else in src/ — import from here.
 */

export const PROSPECTOR_ENGINE_URL =
  import.meta.env.VITE_PROSPECTOR_ENGINE_URL ?? 'http://localhost:4001';

export const KNOWLEDGE_ENGINE_URL =
  import.meta.env.VITE_KNOWLEDGE_ENGINE_URL ?? 'http://localhost:4002';

export const ORCHESTRATION_ENGINE_URL =
  import.meta.env.VITE_ORCHESTRATION_ENGINE_URL ?? 'http://localhost:4004';

export const AUTHORING_ENGINE_URL =
  import.meta.env.VITE_AUTHORING_ENGINE_URL ?? 'http://localhost:4005';

export const STUDIO_ENGINE_URL =
  import.meta.env.VITE_STUDIO_ENGINE_URL ?? 'http://localhost:4006';

export const CANON_ENGINE_URL =
  import.meta.env.VITE_CANON_ENGINE_URL ?? 'http://localhost:4007';

export const DOCS_SERVER_URL =
  import.meta.env.VITE_DOCS_SERVER_URL ?? 'http://localhost:4008';

export const ASSEMBLY_ENGINE_URL =
  import.meta.env.VITE_ASSEMBLY_ENGINE_URL ?? 'http://localhost:4009';

export const PUBLISHING_ENGINE_URL =
  import.meta.env.VITE_PUBLISHING_ENGINE_URL ?? 'http://localhost:4010';

import { resolveIntegrationsEngineUrl } from './envConfig';

export const INTEGRATIONS_ENGINE_URL = resolveIntegrationsEngineUrl();

export const CURATION_ENGINE_URL =
  import.meta.env.VITE_CURATION_ENGINE_URL ?? 'http://localhost:4101';
